export const QUESTION_TYPES = {
  ADD_MC: 'ADD_MC',
  ADD_DC: 'ADD_DC',
  ADD_DA: 'ADD_DA',
  ADD_PRECEDENTS: 'ADD_PRECEDENTS',
  SELECT_PRECEDENT: 'SELECT_PRECEDENT',
  RESET_QUESTIONS: 'RESET_QUESTIONS',
};
